export const reportDataMedChangesPharma = {
  data: {
    rpp: '/COROTA/MedChanges',
    pts: 1,
    fr: true,
    dn: '',
    rp: '',
  },
  dataDownloadPDF: {
    rpp: '/COROTA/MedChanges',
    pts: 0,
    fmt: 2,
    dn: '',
    rp: '',
  },
  dataDownloadExcel: {
    rpp: '/COROTA/MedChanges',
    pts: 0,
    fmt: 3,
    dn: '',
    rp: '',
  },
  dataRenderReport: {
    rpp: '/COROTA/MedChanges',
    pts: 0,
    z: 100,
    htmf: false,
    fmt: 2,
    dl: false,
    dn: '',
    rp: '',
  },
};

// "Mostrar" section: direct logic (checked = Show*=true)
export const showFiltersPharma = [
  { label: 'Emblistados', formControlName: 'checkboxEmblistables' },
  { label: 'N/E', formControlName: 'checkboxNE' },
];

// "Ocultar" section: inverted logic (checked = Show*=false)
export const hideFiltersPharma = [
  { label: 'S/P', formControlName: 'checkboxSP' },
  { label: 'Agudos', formControlName: 'checkboxAcute' },
  { label: 'Pago', formControlName: 'checkboxPayment' },
];
